import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/http/auth.service';

@Component({
  // Added by fix-standalone-components script
  standalone: false,
  selector: 'app-imprint-page',
  templateUrl: './imprint-page.component.html',
  styleUrls: ['./imprint-page.component.scss'],
  host: { class: 'imprint-page-app' },
  encapsulation: ViewEncapsulation.Emulated,
})
export class ImprintPageComponent implements OnInit {
  constructor(private router: Router, public authService: AuthService) {}

  ngOnInit(): void {}
}
